import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import Screen from '../../Components/Screen'
import { isAdmin, getTeamUrl } from 'Common'
import { createPermitFunction } from '../../Evolve/Utilities/permissions'

import Breadcrumbs from './Components/Breadcrumbs'
import Header from './Components/Header'
import GroupedSettings from './Components/GroupedSettings'

import Filters from './Components/Filters'
import Setting from '../../Modals/Setting'
import User from "../../Modals/User";

// Props:
// settings: array of setting objects
// fetching: boolean indicating if data is being fetched
// searchTerm: string for search input
// filters: filter options object
// pagination: pagination configuration object
// settingModal: modal state object
// componentDidMount: function to call on mount
// onChangeSearch: function for search changes
// onSubmitSearch: function for search submission
// onChangeFilter: function for filter changes
// onChangeTable: function for table changes
// onClickRow: function for row clicks
// onClickExport: function for export button
// onClickNewSetting: function for new setting button
// onCloseSettingModal: function to close setting modal
// didCreateSetting: function called after setting creation
// didUpdateSetting: function called after setting update
// didDeleteSetting: function called after setting deletion
// didDeactivateSetting: function called after setting deactivation
// didReactivateSetting: function called after setting reactivation

class Settings extends React.PureComponent {

  componentDidMount = () => this.props.componentDidMount()

  render() {

    const {
      settings,
      fetching,
      searchTerm,
      filters,
      pagination,
      settingModal,
      userPermissions,
      onChangeSearch,
      onSubmitSearch,
      onChangeFilter,
      onChangeTable,
      onClickRow,
      onClickExport,
      onClickNewSetting,
      onCloseSettingModal,
      didCreateSetting,
      didUpdateSetting,
      didDeleteSetting,
      didDeactivateSetting,
      didReactivateSetting,
    } = this.props

    // Permission check - redirect if user doesn't have access
    const permit = createPermitFunction(userPermissions || [])
    if (!isAdmin() || !permit('settings_admin')) {
      return <Redirect to={getTeamUrl('')} />
    }
     
    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
          onSubmitSearch={onSubmitSearch}
          onClickExport={onClickExport}
          onClickNewSetting={onClickNewSetting}
        />


        
        <GroupedSettings
          settings={settings}
          fetching={fetching}
          onClickRow={onClickRow}
          filters={filters}
          onChangeFilter={onChangeFilter}
        />

	      {settingModal.show && (
        	<Setting
	          id={settingModal.id}
	          onClose={onCloseSettingModal}
	          didCreate={didCreateSetting}
	          didUpdate={didUpdateSetting}
	          didDelete={didDeleteSetting}
	          didDeactivate={didDeactivateSetting}
	          didReactivate={didReactivateSetting}
	        />
        )}

      </Screen> 

    )

  }

}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Settings)
